import React, {useState} from 'react';
import styled from "styled-components";
import {FaTimes, FaBars} from "react-icons/fa";
import {Link}  from "react-router-dom";

const Header = () => {

  const [click, setClick] = useState(false);

  const HandleClick = () =>{
    setClick(!click)
  };

  return (
    <Container>
        <Wrapper>
            <LogoHold>
              <h1 style={{fontSize: "28px"}}>Dev.Cynthia</h1>
            </LogoHold>
            <NavHold click={click} onClick={HandleClick}>
              <Span style={{color: "orangered"}} to="/">Home</Span>
              <Span style={{color: "green"}} to="/dev/about">About</Span>
              <Span style={{color: "blue"}} to="/dev/projects">Projects</Span>
              {/* <Span to="/dev/contact">Contact</Span> */}
              <Span style={{color: "purple"}} to="/dev/blog">Blog</Span>
              {/* <Span style={{color: "whitesmoke"}} to="/">Contact</Span> */}
            </NavHold>
            <BurgerHold onClick={HandleClick}>
              {click? <FaTimes/> :
              (<FaBars/>)
            }
            </BurgerHold>
        </Wrapper>
    </Container>
  )
};

export default Header;


const Container = styled.div`
width: 100%;
height: 90px;
/* background-color: white; */
color: #000;
display: flex;
justify-content: center;
align-items: center;
position: fixed;
z-index: 1;

background:   rgba(255, 255, 255, 0.1);
backdrop-filter: blur(20px);

@media Screen and (max-width: 768px){
  background: black;
  backdrop-filter: none;
}
`;
const Wrapper = styled.div`
width: 90%;
height: 90%;
display: flex;
justify-content: space-between;
align-items: center;

`;
const LogoHold = styled.div`
width: 10%;
height: 100%;
display: flex;
justify-content: center;
align-items: center;
cursor: pointer;
font-size: 55px;
color: whitesmoke;
font-weight: bold;
font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
@media Screen and (max-width: 768px){
  width: 50%;
  /* background-color: red; */
}
`;
const NavHold = styled.div`
width: 40%;
height: 100%;
display: flex;
justify-content: space-between;
align-items: center;



@media Screen and (max-width: 768px){
    flex-direction: column;
    width: 100%;
    /* position: absolute; */
    /* background-color: rgba(0, 0, 0, 0.1); */
    height: 80vh;
    transition: all ease 1s;
    justify-content: space-evenly;
    left: ${({click}) => (click? 0 : "-100%")};
    margin-top: 90px;
    backdrop-filter: blur(9px);
    position: fixed;
    top:0;
}

`;
const Span = styled(Link)`
cursor: pointer;
color: #000;
font-size: 20px;
font-weight: bold;
text-decoration: none;

:hover{
text-decoration: underline solid white 1px;
}

@media Screen and (max-width: 768px){
font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
}
`;

const BurgerHold = styled.div`
display: none;
z-index: 2;
right: 30px;
font-size: 25px;
cursor: pointer;
color: whitesmoke;

@media Screen and (max-width: 768px){
  display: block;
  position: absolute;

}

`;

